import "./index.scss";

const GetOnBoard = () => {
  return (
    <>
      <div className="getOnBoard">
        <div className="w3-container">
          <div className="w3-row">
            <div align="center">
              <h2 className="getOnBoardTittle">Get Your School On Board</h2>
            </div>
          </div>
          <div className="w3-row">
            <div className="w3-half">
              <h5 className="getOnBoardTittleOne" align="center">Reasons to  Choose <br /> MyGradCard</h5>
              <div className="w3-row">
                <ul>
                  <li>All-in-one. EVERYTHING you need in one unified school <br /> management system.</li>
                  <li>Extremely configurable & tailored to your school</li>
                  <li>Very easy to use. Nothing is more than a few clicks away</li>
                  <li>Our pricing is straight forward. No hidden or inflated costs</li>
                  <li>98% satisfaction rating. Admins love our support!
                  </li>
                </ul>
              </div>

              <div className="w3-row" align="center">
                <p>Reasons to choose MySchool
                  All-in-one. EVERYTHING you need in one unified school management system.
                  Extremely configurable & tailored to your school.
                  Very easy to use. Nothing is more than a few clicks away.
                  Our pricing is straight forward. No hidden or inflated costs.
                  98% satisfaction rating. Admins love our support!
                  " I was talking to our Development Director after my meeting with you and I mentioned that you asked me to give MySchool a rating and I gave you a 10.... She said she would have given you a 12!  Support is awesome - there is nothing like it. You are always there for us and quick on top of that! "</p>
              </div>
            </div>

            <div className="w3-half">
              <h5 className="getOnBoardTittleTwo">Request a demo</h5>
              <form>
                <div className="w3-row">
                  <div className="w3-third">
                    <p>First Name</p>
                    <input type="text" />
                  </div>
                  <div className="w3-third">
                    <p>Last Name</p>
                    <input type="text" />
                  </div>
                  <div className="w3-third">
                    <p>School Name</p>
                    <input type="text" />
                  </div>
                </div>

                <div className="w3-row">
                  <div className="w3-third">
                    <p>Work Email</p>
                    <input type="text" />
                  </div>
                  <div className="w3-third">
                    <p>Phone Number</p>
                    <input type="text" />
                  </div>
                  <div className="w3-third">
                    <p>School Website</p>
                    <input type="text" />
                  </div>
                </div>

                <div className="w3-row">
                  <div className="w3-third">
                    <p>Number Of Student</p>
                    <select>
                      <option selected>Please Select</option>
                      <option>10 - 100</option>
                      <option>100 -500</option>
                      <option>500 - 1000</option>
                      <option>1000 -10000</option>
                      <option>10000 - 20000</option>
                      <option>20000+</option>
                    </select>
                  </div>
                  <div className="w3-third">
                    <p>Your Role</p>
                    <select>
                      <option selected>Please Select</option>
                      <option>School Administrator</option>
                      <option>IT Management</option>
                      <option>School Management</option>
                      <option>System Resellers</option>
                      <option>Constant</option>
                    </select>
                  </div>
                  <div className="w3-third">
                    <p>Country</p>
                    <select>
                      <option selected>Please Select</option>
                      <option>Nigeria</option>
                      <option>USA</option>
                      <option>Canada</option>
                      <option>South Africa</option>
                      <option>China</option>
                    </select>
                  </div>
                </div>

                <div className="w3-row">
                  <p>How Would You Describe Your Needs?</p>
                  <select>
                    <option selected>Please Select</option>
                    <option>A young school that want to move away from patched-up solution</option>
                    <option>Needs a flexible system and/or to streamline our systems and processes</option>
                    <option>A school Network that need a customizable enterprise-scale solutions</option>
                    <option>A constant / resellers trying to establish what MyGradeCard is about</option>
                    <option>Different from the ones listed above</option>
                  </select>
                </div>

                <div className="w3-row">
                  <p>Tell us a little more about your SIS needs</p>
                  <textarea cols="70"></textarea>
                </div>

                <div className="w3-row">
                  <p className="formText">MyGradeCard needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our Privacy Policy.</p>
                </div>

                <div className="w3-row">
                  <div align="center">
                    <button className="btn">Request Your Demo</button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default GetOnBoard;
